import { Svg } from '@innovyze/stylovyze/lib/components';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
import { rem } from '@innovyze/stylovyze/lib/utils/styles';
import * as React from 'react';
import styled from 'styled-components';
import FolderIcon from './Folder.svg';
export const NoNewNotifications = () => {
    const { t } = useGlobalization();
    return (React.createElement(Container, null,
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            React.createElement(Svg, { svg: FolderIcon }),
            React.createElement(NotificationTurnedOffText, null, t('Notification is turned off.'))),
        React.createElement(NotReceivingNewNotificationsText, null, t('You are not receiving new notifications.'))));
};
const Container = styled.div `
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: ${rem(8)};
	padding: ${rem(4)} 0;
	background-color: #f5f5f5;
`;
const NotificationTurnedOffText = styled.p `
	font-weight: 700 !important;
	margin: 0 0 0 ${rem(4)} !important;
`;
const NotReceivingNewNotificationsText = styled.p `
	font-size: ${rem(12)} !important;
	margin: 0 !important;
`;
